// API base URL: build-time env var REACT_APP_API_BASE_URL overrides the default.
// Default is the production URL (cloudhints.com domain) which only resolves once
// DNS is mapped to Cloud Run. For testing pre-cutover, build with:
//   REACT_APP_API_BASE_URL=https://cloudhints-api-rfgjuwozhq-ez.a.run.app yarn build

const DEFAULT_BASE = 'https://ch-api.cloudhints.com';
const BASE = (process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE).replace(/\/+$/, '');

export const API_BASE_URL  = BASE;
export const AUTH_ENDPOINT = `${BASE}/adminauth/`;



// WEBPACK FOOTER //
// ./src/endpoints.js